/* eslint-disable no-useless-escape */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-undef */
/* eslint-disable max-len */
// eslint-disable-next-line object-shorthand

const validator = {
    restrictedContentTypeList: [],
    verifyEmailAddresses: function (emails) {
        if (!emails) return false;
        // expects a string of comma separated emails
        const emailList = emails.split(',');
        let isValidate = true;
        if (emailList === '' || emailList === null) {
            isValidate = false;
        }
        else {
            for (let i = 0; i < emailList.length; i++) {
                isValidate = validator.verifyEmailAddress(emailList[i]);
                if (!isValidate) {
                    break;
                }
            }
        }
        return isValidate;
    },
    verifyEmailAddress: function (emailAddress) {
        // eslint-disable-next-line no-useless-escape
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const regex2 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        return regex.test(emailAddress.trim()) && regex2.test(emailAddress.trim());
    },

    verifyPhoneNumber: function (phoneNumber) {
        const regex = /^(?:\+?\d{1,4})?[\s.-]?\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,9}$/;
        return regex.test(phoneNumber.trim());
    },

    validateSpecialCharactor: function (value, contentType) {
        if (!value || typeof value !== 'string') return true;

        const isValidContentType = Array.isArray(this.restrictedContentTypeList) &&
            this.restrictedContentTypeList.includes(contentType);

        if (isValidContentType) {
            const forbiddenCharacters = $('#hiddenForbiddenCharacters').val().trim();

            if (!forbiddenCharacters) return true;

            const escapedChars = forbiddenCharacters
                .split(',')
                .map((char) => char.trim())
                .filter((char) => char !== '')
                .map((char) => char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

            const regex = new RegExp(`(${escapedChars.join('|')})`, 'g');

            return !regex.test(value.trim());
        }
        const defaultRegexPattern = /[,""#%{}|\\\^\~\[\]@&+:;=\?]/g;

        return !defaultRegexPattern.test(value.trim());
    },
    isValidImageUrl: function (url) {
        const cleanUrl = url.split('?')[0];
        return /\.(gif|jpg|jpeg|jfif|png|svg|tif|tiff|webp|ico)$/i.test(cleanUrl);
    },
    verifyFolderName: function (folderName) {
        const regex = /^[a-zA-Z0-9 _/,-]+$/;
        return regex.test(folderName.trim());
    },
    validateModalTitle: function (titleInputId) {
        const titleInput = document.getElementById(titleInputId);
        if (!titleInput) return false;
        titleInput.classList.remove('input-validation-error');
        if (titleInput.value.trim() === '') {
            titleInput.classList.add('input-validation-error');
            return false;
        }
        return true;
    },
    validateAdditionalEmails: function (inputId, errorSelector, notifySelector, dropdownSelector) {
        var additionalEmails = $(inputId).val();

        if (additionalEmails && additionalEmails.trim() !== "") {
            var valid = validator.verifyEmailAddresses(additionalEmails);

            if (!valid) {
                $(inputId).addClass("input-validation-error");
                $(errorSelector + ", " + notifySelector).show();
                $(dropdownSelector).removeClass("border border-danger");
                return false;
            } else {
                $(inputId).removeClass("input-validation-error");
                $(errorSelector + ", " + notifySelector).hide();
            }
        }
       return true;
   }
};
